import {
    ALLINFLUENCERSDETAILS,
    SimpleCarousel,
    SUBTITLE,
    TITLE,
} from '@eventbrite/collection-carousel';
import { Typography } from '@eventbrite/marmalade';
import React, { FunctionComponent } from 'react';
import { Influencer } from './Influencer';
import styles from './InfluencerCuration.module.scss';

interface InfluencerCurationProps {
    source: string;
}

export type InfluencerType = {
    title: string;
    name: string;
    social: Social[];
    image: string;
    collection_id: string;
};

export interface Social {
    handle: string;
    platform: string;
}

const HeaderTitle = () => {
    return (
        <Typography variant="heading-sm" className={styles.heading}>
            {TITLE}
        </Typography>
    );
};

const SubTitle = () => {
    return (
        <Typography variant={'body-md'} className={styles.subtitle}>
            {SUBTITLE}
        </Typography>
    );
};

const InfluencerCuration: FunctionComponent<InfluencerCurationProps> = (
    props,
) => {
    const { source } = props;
    return (
        <div className={styles.influencer_module}>
            <div className={styles.influencer_curation_simple_carousel}>
                <SimpleCarousel
                    headerTitle={<HeaderTitle />}
                    subtitle={<SubTitle />}
                    slidesVisible={{ desktop: 3, tablet: 2 }}
                >
                    {ALLINFLUENCERSDETAILS.map((influencer: InfluencerType) => (
                        <Influencer
                            influencer={influencer}
                            key={influencer.collection_id}
                            source={source}
                        />
                    ))}
                </SimpleCarousel>
            </div>
        </div>
    );
};
export default InfluencerCuration;
